import type { IconProps } from './../../models/icon';

export function BankIcon({
  width = 24,
  height = 24,
  secondaryColor = 'var(--color-200)',
  className = '',
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width={width}
      height={height}
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          fill="#fff"
          d="M3.42871 18.8571V9.42856H20.5716V18.8571H3.42871Z"
        />
        <path
          fill={secondaryColor}
          d="M22.1315 9.42854H1.86868C0.908684 9.42854 0.497255 8.38283 1.25154 7.88568L11.383 1.25141C11.57 1.14137 11.7831 1.08334 12.0001 1.08334C12.2171 1.08334 12.4302 1.14137 12.6172 1.25141L22.7487 7.88568C23.503 8.38283 23.0915 9.42854 22.1315 9.42854Z"
        />
        <path
          fill={secondaryColor}
          d="M22.2855 18.8571H1.71408C1.24069 18.8571 0.856934 19.2409 0.856934 19.7143V22.2857C0.856934 22.759 1.24069 23.1428 1.71408 23.1428H22.2855C22.7588 23.1428 23.1426 22.759 23.1426 22.2857V19.7143C23.1426 19.2409 22.7588 18.8571 22.2855 18.8571Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M22.1315 9.42854H1.86868C0.908684 9.42854 0.497255 8.38283 1.25154 7.88568L11.383 1.25141C11.57 1.14137 11.7831 1.08334 12.0001 1.08334C12.2171 1.08334 12.4302 1.14137 12.6172 1.25141L22.7487 7.88568C23.503 8.38283 23.0915 9.42854 22.1315 9.42854Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M22.2855 18.8571H1.71408C1.24069 18.8571 0.856934 19.2409 0.856934 19.7143V22.2857C0.856934 22.759 1.24069 23.1428 1.71408 23.1428H22.2855C22.7588 23.1428 23.1426 22.759 23.1426 22.2857V19.7143C23.1426 19.2409 22.7588 18.8571 22.2855 18.8571Z"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M3.42871 9.42856V18.8571"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M7.71436 9.42856V18.8571"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M12 9.42856V18.8571"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M16.2856 9.42856V18.8571"
        />
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.7"
          d="M20.5713 9.42856V18.8571"
        />
      </g>
    </svg>
  );
}
